import { MAX_COMPARE_SCENARIOS } from "@shared/constants";

/**
 * The `/compare?ids=a,b,c` search parameter, in both directions.
 *
 * It stays a comma-joined *string* on the wire rather than a repeated parameter
 * or a JSON array, because this URL exists to be pasted into a message and both
 * of those shapes get mangled on the way — the first by anything that keeps only
 * the last value, the second by the punctuation an encoder adds to it.
 *
 * Parsing is deliberately forgiving: a hand-edited list loses its blanks, its
 * duplicates and anything past the fourth id here, where the page can show an
 * empty state, rather than at the API as a 400.
 */

export function parseCompareIds(raw: unknown): string[] {
  const list = Array.isArray(raw) ? raw : typeof raw === "string" ? raw.split(",") : [];
  const ids = list.map((value) => String(value).trim()).filter((value) => value.length > 0);
  return [...new Set(ids)].slice(0, MAX_COMPARE_SCENARIOS);
}

export const compareSearch = (ids: readonly string[]): { ids: string } => ({
  ids: parseCompareIds([...ids]).join(","),
});
